import moment from "moment";
import { ServiceStatus } from "@/enums/ServiceStatus";
import Loader from "@/components/loader/Loader.vue";
import { FacilitySettingsModel } from "@/models/FacilitySettings";

export default {
  name: "LifestyleProgramsReport",
  data() {
    return {
      period: "week",
      startDate: moment().subtract(1, "week").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      loading: true,
      reportData: null,
      serviceStatus: ServiceStatus,
      periods: [
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Week"], value: "week" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Month"], value: "month" },
        { title: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Year"], value: "year" }
      ],
      picker: {
        start: false,
        end: false
      },
      headerProgramsCategories: [
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Name"],
          value: "name",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.Color"],
          value: "colorCode",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.Programs"],
          value: "programsCount",
        }
      ],
      defaultHeader: [
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Name"],
          value: "name",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.ScheduledEvents"],
          value: "scheduledEventsCount",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.AvgAttendeesCount"],
          value: "avgAttendeesCount",
        },
      ],
      headerPrograms: [
        {
          text: this.$i18n.messages[this.$i18n.locale]["GeneralTranslations.Name"],
          value: "name",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.ScheduledEvents"],
          value: "scheduledEventsCount",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.AvgAttendeesCount"],
          value: "avgAttendeesCount",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.Pictures"],
          value: "picturesCount",
        },
        {
          text: this.$i18n.messages[this.$i18n.locale]["LifestyleProgramsReport.Likes"],
          value: "likesCount",
        }
      ]
    }
  },
  components: {
    Loader
  },
  computed: {
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    facilities() {
      return this.$store.state.facilityModule.facilities;
    },
    facilitiesIds() {
      return this.$store.state.facilityModule.facilities.map(x => x.id);
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    },
    mostPopularPrograms() {
      return this.reportData?.mostPopularPrograms
    },
    leastPopularPrograms() {
      return this.reportData?.leastPopularPrograms
    },
    programs() {
      return this.reportData?.programs
    },
    categories() {
      return this.reportData?.categories
    }
  },
  methods: {
    routeToReports() {
      this.$router.push("/reports");
    },

    async loadReport() {
      this.loading = true
      this.reportData = await this.$store.dispatch("getLifestyleProgramsReport", { startDate: moment(this.startDate).startOf('day').toDate(), endDate: moment(this.endDate).endOf('day').toDate() });
      this.loading = false
    },

    async handleChangePeriod(period) {
      this.startDate = moment()
        .subtract(1, period)
        .toISOString()
        .substring(0, 10);

      this.endDate = moment()
        .toISOString()
        .substring(0, 10);

      await this.loadReport();
    },

  },
  async created() {
    await this.$store.dispatch("getFacility");
    await this.loadReport();
  }
}